(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9531],{

/***/ 48068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ setStaffNumber; },
/* harmony export */   "BB": function() { return /* binding */ setCoupon; },
/* harmony export */   "Er": function() { return /* binding */ removeOneCustomization; },
/* harmony export */   "F1": function() { return /* binding */ setDistrict; },
/* harmony export */   "Fx": function() { return /* binding */ resetForm; },
/* harmony export */   "Hx": function() { return /* binding */ selectBookForm; },
/* harmony export */   "K0": function() { return /* binding */ replaceExistingServices; },
/* harmony export */   "LN": function() { return /* binding */ setVat; },
/* harmony export */   "NV": function() { return /* binding */ setReferrer; },
/* harmony export */   "PY": function() { return /* binding */ addOneCustomization; },
/* harmony export */   "Pb": function() { return /* binding */ setBookedSession; },
/* harmony export */   "Pj": function() { return /* binding */ setPaymentInfo; },
/* harmony export */   "Pq": function() { return /* binding */ initForm; },
/* harmony export */   "Q5": function() { return /* binding */ setCounty; },
/* harmony export */   "Q_": function() { return /* binding */ updateMoveInAddressByIndex; },
/* harmony export */   "R_": function() { return /* binding */ removeMoveInAddressByIndex; },
/* harmony export */   "Sh": function() { return /* binding */ removeOneService; },
/* harmony export */   "TZ": function() { return /* binding */ initCustomizations; },
/* harmony export */   "XD": function() { return /* binding */ setContactDate; },
/* harmony export */   "XH": function() { return /* binding */ setBookAddressDetails; },
/* harmony export */   "Yk": function() { return /* binding */ setBookName; },
/* harmony export */   "_C": function() { return /* binding */ setSelfBookingCopyMode; },
/* harmony export */   "_t": function() { return /* binding */ toggleCustomization; },
/* harmony export */   "af": function() { return /* binding */ clearVat; },
/* harmony export */   "b6": function() { return /* binding */ removeEmptyCustomizationItem; },
/* harmony export */   "bk": function() { return /* binding */ setObjectNo; },
/* harmony export */   "c_": function() { return /* binding */ changeCustomizationTextValue; },
/* harmony export */   "et": function() { return /* binding */ setVerificationPhone; },
/* harmony export */   "h1": function() { return /* binding */ replaceExistingCustomizations; },
/* harmony export */   "hU": function() { return /* binding */ setSelfBookingCopyTimes; },
/* harmony export */   "hq": function() { return /* binding */ addMoveInAddress; },
/* harmony export */   "id": function() { return /* binding */ setSelfBookingReason; },
/* harmony export */   "jH": function() { return /* binding */ toggleService; },
/* harmony export */   "jX": function() { return /* binding */ setBookAddressHasElevator; },
/* harmony export */   "jh": function() { return /* binding */ setSiteImages; },
/* harmony export */   "lX": function() { return /* binding */ changeCustomizationDateValue; },
/* harmony export */   "mA": function() { return /* binding */ setBookNote; },
/* harmony export */   "ne": function() { return /* binding */ addOneService; },
/* harmony export */   "ou": function() { return /* binding */ clearForm; },
/* harmony export */   "tv": function() { return /* binding */ removeUnselectedCustomizationItem; },
/* harmony export */   "u9": function() { return /* binding */ setCustomerBudget; },
/* harmony export */   "vR": function() { return /* binding */ setBookEmail; },
/* harmony export */   "vi": function() { return /* binding */ setBookPhone; }
/* harmony export */ });
/* unused harmony exports bookFormSlice, fillInForm, setExpectServiceTimeOne, setExpectServiceTimeTwo, cancelBookedSession, cancelExpectServiceTimeOne, cancelExpectServiceTimeTwo, replaceMoveInAddress */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79036);
/* harmony import */ var redux_persist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97568);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79697);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69884);



/*
 * services and customizations field are normalized:
 *
 * services format example: {
 *  'id_1': { serviceId: 'id_1', count: 1 },
 *  'id_2': { serviceId: 'id_2', count: 3 },
 * }
 *
 * customizations format example: {
 *  'customization_id1': {
 *    'id_1': { itemId: 'id_1', count: 1 },
 *    'id_2': { itemId: 'id_2', count: 3 },
 *  },
 *  'customization_id2': {
 *    'id_1': { itemId: 'id_1', count: 1 },
 *    'id_2': { itemId: 'id_2', count: 3 },
 *  }
 * }
 */ const initialState = {
    classificationId: "",
    name: "",
    phone: "",
    email: "",
    services: {},
    address: {
        county: "",
        district: "",
        details: "",
        hasElevator: false
    },
    staffNumber: "",
    customizations: {},
    siteImages: {},
    paymentInfo: {
        method: "cash"
    },
    note: "",
    expectServiceTimes: [],
    customerBudget: "",
    // 自建單欄位
    verificationPhone: "",
    objectNo: "",
    selfBookingInfo: {
        reason: "",
        // fromUserBookedReservation: null, // 無輸入時不存在
        copyOpt: {
            mode: "none",
            times: 0
        }
    },
    selectedServicePackageInfo: {},
    // for unordered reservation
    contactDate: ""
};
const bookFormSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "bookForm",
    initialState: initialState,
    reducers: {
        initForm: (state, action)=>{
            const { services , classification , customizations , currentForm  } = action.payload;
            let form = state;
            if (state.classificationId !== classification._id) {
                // remove all except user data
                form = {
                    ...initialState,
                    classificationId: classification._id,
                    name: state.name,
                    phone: state.phone,
                    email: state.email,
                    address: state.address,
                    vatNo: state.vatNo,
                    vatTitle: state.vatTitle,
                    objectNo: state.objectNo,
                    staffNumber: state.staffNumber,
                    note: state.note
                };
                if (classification.mode === "relocation") {
                    form.moveInAddress = [
                        {
                            type: "main"
                        }
                    ];
                }
                form.customizations = (customizations || []).filter((customization)=>customization.selectType === "single").map((customization)=>{
                    var _customization_items, _customization_items_, _customization_items1, _customization_items_1;
                    return {
                        [customization._id]: {
                            [(_customization_items = customization.items) === null || _customization_items === void 0 ? void 0 : (_customization_items_ = _customization_items[0]) === null || _customization_items_ === void 0 ? void 0 : _customization_items_._id]: {
                                itemId: (_customization_items1 = customization.items) === null || _customization_items1 === void 0 ? void 0 : (_customization_items_1 = _customization_items1[0]) === null || _customization_items_1 === void 0 ? void 0 : _customization_items_1._id,
                                count: 1
                            }
                        }
                    };
                }).reduce((result, obj)=>({
                        ...result,
                        ...obj
                    }), {});
            }
            return form;
        },
        clearForm: (state, action)=>{
            return {
                ...initialState
            };
        },
        resetForm: (state, action)=>{
            return {
                ...initialState,
                name: state.name,
                phone: state.phone,
                email: state.email,
                address: state.address,
                vatNo: state.vatNo,
                vatTitle: state.vatTitle
            };
        },
        // TODO: 移除此action，
        // 這類action會導致參數被不知道哪裡來的事件修改而難以追蹤
        fillInForm: (state, action)=>{
            const payload = (action === null || action === void 0 ? void 0 : action.payload) || {};
            return {
                ...state,
                ...payload
            };
        },
        initCustomizations: (state, action)=>{
            action.payload.forEach((customization)=>{
                if (customization.selectType === "single" && !state.customizations[customization._id]) {
                    var _customization_items, _customization_items_, _customization_items1, _customization_items_1;
                    state.customizations[customization._id] = {
                        [(_customization_items = customization.items) === null || _customization_items === void 0 ? void 0 : (_customization_items_ = _customization_items[0]) === null || _customization_items_ === void 0 ? void 0 : _customization_items_._id]: {
                            itemId: (_customization_items1 = customization.items) === null || _customization_items1 === void 0 ? void 0 : (_customization_items_1 = _customization_items1[0]) === null || _customization_items_1 === void 0 ? void 0 : _customization_items_1._id,
                            count: 1
                        }
                    };
                }
            });
        },
        setCounty: (state, action)=>{
            state.address.county = action.payload;
        },
        setDistrict: (state, action)=>{
            state.address.district = action.payload;
        },
        // handle service modification
        addOneService: (state, action)=>{
            const service = action.payload;
            if (state.services[service === null || service === void 0 ? void 0 : service._id]) {
                state.services[service === null || service === void 0 ? void 0 : service._id].count += 1;
            } else {
                state.services[service === null || service === void 0 ? void 0 : service._id] = {
                    serviceId: service === null || service === void 0 ? void 0 : service._id,
                    count: 1
                };
            }
        },
        removeOneService: (state, action)=>{
            var _state_services_service__id;
            const service = action.payload;
            if (((_state_services_service__id = state.services[service === null || service === void 0 ? void 0 : service._id]) === null || _state_services_service__id === void 0 ? void 0 : _state_services_service__id.count) <= 1) {
                delete state.services[service === null || service === void 0 ? void 0 : service._id];
            } else {
                state.services[service === null || service === void 0 ? void 0 : service._id].count -= 1;
            }
        },
        toggleService: (state, action)=>{
            const service = action.payload;
            if (state.services[service === null || service === void 0 ? void 0 : service._id]) {
                delete state.services[service === null || service === void 0 ? void 0 : service._id];
            } else {
                state.services[service === null || service === void 0 ? void 0 : service._id] = {
                    serviceId: service === null || service === void 0 ? void 0 : service._id,
                    count: 1
                };
            }
        },
        replaceExistingServices: (state, action)=>{
            const service = action.payload;
            state.services = {
                [service === null || service === void 0 ? void 0 : service._id]: {
                    serviceId: service === null || service === void 0 ? void 0 : service._id,
                    count: 1
                }
            };
            state.customizations = {};
            state.selectedServicePackageInfo = service === null || service === void 0 ? void 0 : service.packageInfo;
        },
        setBookedSession: (state, action)=>{
            state.bookedSession = action.payload;
        },
        setExpectServiceTimeOne: (state, action)=>{
            var _state_bookedSession;
            if (!(state === null || state === void 0 ? void 0 : (_state_bookedSession = state.bookedSession) === null || _state_bookedSession === void 0 ? void 0 : _state_bookedSession.from)) {
                state.bookedSession = action.payload;
            } else {
                state.expectServiceTimes[0] = action.payload;
            }
        },
        setExpectServiceTimeTwo: (state, action)=>{
            var _state_bookedSession, _state_expectServiceTimes, _state_expectServiceTimes_;
            if (!(state === null || state === void 0 ? void 0 : (_state_bookedSession = state.bookedSession) === null || _state_bookedSession === void 0 ? void 0 : _state_bookedSession.from)) {
                state.bookedSession = action.payload;
            } else if (!((_state_expectServiceTimes = state.expectServiceTimes) === null || _state_expectServiceTimes === void 0 ? void 0 : (_state_expectServiceTimes_ = _state_expectServiceTimes[0]) === null || _state_expectServiceTimes_ === void 0 ? void 0 : _state_expectServiceTimes_.from)) {
                state.expectServiceTimes[0] = action.payload;
            } else {
                state.expectServiceTimes[1] = action.payload;
            }
        },
        cancelBookedSession: (state, action)=>{
            if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.expectServiceTimes)) {
                const [first, ...rest] = state.expectServiceTimes;
                state.bookedSession = first;
                state.expectServiceTimes = rest;
            } else {
                state.bookedSession = null;
            }
        },
        cancelExpectServiceTimeOne: (state, action)=>{
            var _state_expectServiceTimes;
            if ((_state_expectServiceTimes = state.expectServiceTimes) === null || _state_expectServiceTimes === void 0 ? void 0 : _state_expectServiceTimes[1]) {
                const [first, ...rest] = state.expectServiceTimes;
                state.expectServiceTimes = rest;
            } else {
                state.expectServiceTimes = [];
            }
        },
        cancelExpectServiceTimeTwo: (state, action)=>{
            const [first, second, ...rest] = state.expectServiceTimes;
            state.expectServiceTimes = [
                first,
                ...rest
            ];
        },
        // handle customization modification
        addOneCustomization: (state, action)=>{
            const { item , customizationId  } = action.payload;
            if (!state.customizations[customizationId]) {
                state.customizations[customizationId] = {};
            }
            if (state.customizations[customizationId][item._id]) {
                state.customizations[customizationId][item._id].count += 1;
            } else {
                state.customizations[customizationId][item._id] = {
                    itemId: item._id,
                    count: 1
                };
            }
        },
        removeOneCustomization: (state, action)=>{
            var _state_customizations, _state_customizations_customizationId, _state_customizations_customizationId_item__id;
            const { item , customizationId  } = action.payload;
            if (((_state_customizations = state.customizations) === null || _state_customizations === void 0 ? void 0 : (_state_customizations_customizationId = _state_customizations[customizationId]) === null || _state_customizations_customizationId === void 0 ? void 0 : (_state_customizations_customizationId_item__id = _state_customizations_customizationId[item._id]) === null || _state_customizations_customizationId_item__id === void 0 ? void 0 : _state_customizations_customizationId_item__id.count) <= 1) {
                var _state_customizations1, _state_customizations_customizationId1, _state_customizations_customizationId_item__id1;
                if ((_state_customizations1 = state.customizations) === null || _state_customizations1 === void 0 ? void 0 : (_state_customizations_customizationId1 = _state_customizations1[customizationId]) === null || _state_customizations_customizationId1 === void 0 ? void 0 : (_state_customizations_customizationId_item__id1 = _state_customizations_customizationId1[item._id]) === null || _state_customizations_customizationId_item__id1 === void 0 ? void 0 : _state_customizations_customizationId_item__id1.customizedValue) {
                    state.customizations[customizationId][item._id].count = 0;
                } else {
                    delete state.customizations[customizationId][item._id];
                }
                if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.customizations[customizationId])) {
                    delete state.customizations[customizationId];
                }
            } else {
                state.customizations[customizationId][item._id].count -= 1;
            }
        },
        toggleCustomization: (state, action)=>{
            var _state_customizations, _state_customizations_customizationId;
            const { item , customizationId  } = action.payload;
            if ((_state_customizations = state.customizations) === null || _state_customizations === void 0 ? void 0 : (_state_customizations_customizationId = _state_customizations[customizationId]) === null || _state_customizations_customizationId === void 0 ? void 0 : _state_customizations_customizationId[item._id]) {
                delete state.customizations[customizationId][item._id];
                if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.customizations[customizationId])) {
                    delete state.customizations[customizationId];
                }
            } else {
                if (!state.customizations[customizationId]) {
                    state.customizations[customizationId] = {};
                }
                state.customizations[customizationId][item._id] = {
                    itemId: item._id,
                    count: 1
                };
            }
        },
        replaceExistingCustomizations: (state, action)=>{
            const { item , customizationId , text  } = action.payload;
            // Remove unselected items, but keep the customizedValue even unselected
            for(const itemId in state.customizations[customizationId]){
                if (itemId !== item._id) {
                    if (state.customizations[customizationId][itemId].customizedValue) {
                        state.customizations[customizationId][itemId].count = 0;
                    } else {
                        delete state.customizations[customizationId][itemId];
                    }
                }
            }
            if (!state.customizations[customizationId]) {
                state.customizations[customizationId] = {};
            }
            state.customizations[customizationId][item._id] = {
                itemId: item._id,
                count: 1
            };
            if (text) {
                state.customizations[customizationId][item._id].customizedValue = text;
            }
        },
        changeCustomizationTextValue: (state, action)=>{
            var _state_customizations_customizationId;
            const { item , customizationId , text  } = action.payload;
            if (!state.customizations[customizationId]) {
                state.customizations[customizationId] = {};
            }
            if (!((_state_customizations_customizationId = state.customizations[customizationId]) === null || _state_customizations_customizationId === void 0 ? void 0 : _state_customizations_customizationId[item._id])) {
                state.customizations[customizationId][item._id] = {
                    itemId: item._id,
                    count: 0,
                    customizedValue: text
                };
            } else {
                state.customizations[customizationId][item._id].customizedValue = text;
            }
        },
        changeCustomizationDateValue: (state, action)=>{
            var _state_customizations_customizationId;
            const { item , customizationId , date  } = action.payload;
            if (!state.customizations[customizationId]) {
                state.customizations[customizationId] = {};
            }
            if (!((_state_customizations_customizationId = state.customizations[customizationId]) === null || _state_customizations_customizationId === void 0 ? void 0 : _state_customizations_customizationId[item._id])) {
                state.customizations[customizationId][item._id] = {
                    itemId: item._id,
                    count: 1,
                    customizedValue: date
                };
            } else {
                if (date) {
                    state.customizations[customizationId][item._id].customizedValue = date;
                } else {
                    delete state.customizations[customizationId][item._id];
                }
            }
        },
        removeEmptyCustomizationItem: (state, action)=>{
            for(const customizationId in state.customizations){
                for(const itemId in state.customizations[customizationId]){
                    if (!state.customizations[customizationId][itemId].count) {
                        delete state.customizations[customizationId][itemId];
                    }
                }
                if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.customizations[customizationId])) {
                    delete state.customizations[customizationId];
                }
            }
        },
        removeUnselectedCustomizationItem: (state, action)=>{
            const itemKeyToServiceKeyMapping = action.payload;
            const selectedServicesKey = Object.keys(state.services);
            for(const customizationId in state.customizations){
                for(const itemId in state.customizations[customizationId]){
                    const serviceKey = itemKeyToServiceKeyMapping[itemId];
                    if (selectedServicesKey.indexOf(serviceKey) < 0) {
                        delete state.customizations[customizationId][itemId];
                    }
                }
            }
        },
        setBookName: (state, action)=>{
            state.name = action.payload;
        },
        setCustomerBudget: (state, action)=>{
            state.customerBudget = action.payload;
        },
        setBookPhone: (state, action)=>{
            state.phone = action.payload;
        },
        setBookAddressDetails: (state, action)=>{
            state.address.details = action.payload;
        },
        setBookAddressHasElevator: (state, action)=>{
            state.address.hasElevator = action.payload;
        },
        setBookEmail: (state, action)=>{
            state.email = action.payload;
        },
        setVat: (state, action)=>{
            const { vatNo , vatTitle  } = action.payload;
            state.vatNo = vatNo;
            state.vatTitle = vatTitle;
        },
        clearVat: (state, action)=>{
            state.vatNo = "";
            state.vatTitle = "";
        },
        setBookNote: (state, action)=>{
            state.note = action.payload;
        },
        setSiteImages: (state, action)=>{
            state.siteImages = (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(action.payload, (image)=>image._id);
        },
        setCoupon: (state, action)=>{
            state.coupon = action.payload;
        },
        setPaymentInfo: (state, action)=>{
            state.paymentInfo = action.payload;
        },
        // Self Construct
        setVerificationPhone: (state, action)=>{
            state.verificationPhone = action.payload;
        },
        setStaffNumber: (state, action)=>{
            state.staffNumber = action.payload;
        },
        setObjectNo: (state, action)=>{
            state.objectNo = action.payload;
        },
        setSelfBookingReason: (state, action)=>{
            state.selfBookingInfo.reason = action.payload;
        },
        setSelfBookingCopyMode: (state, action)=>{
            state.selfBookingInfo.copyOpt.mode = action.payload;
            if (action.payload === "none") {
                state.selfBookingInfo.copyOpt.times = 0;
            }
        },
        setSelfBookingCopyTimes: (state, action)=>{
            state.selfBookingInfo.copyOpt.times = parseInt(action.payload);
        },
        setReferrer: (state, action)=>{
            state.referrer = action.payload;
        },
        // move in addresses control
        addMoveInAddress: (state, action)=>{
            state.moveInAddress.push({
                type: "others"
            });
        },
        removeMoveInAddressByIndex: (state, action)=>{
            state.moveInAddress.splice(action.payload, 1);
        },
        updateMoveInAddressByIndex: (state, action)=>{
            const { index , address  } = action.payload;
            state.moveInAddress = state.moveInAddress.map((addressInfo, idx)=>idx === index ? address : addressInfo);
        },
        replaceMoveInAddress: (state, action)=>{
            state.moveInAddress = action.payload;
        },
        // unordered reservation
        setContactDate: (state, action)=>{
            state.contactDate = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase(redux_persist__WEBPACK_IMPORTED_MODULE_0__.REHYDRATE, (state, action)=>{
            var _newState_bookForm, _newState_bookForm1, _newState_bookForm2;
            // TODO: control rehydration here
            // migrate old persist data without paymentInfo
            const newState = action.payload;
            if ((newState === null || newState === void 0 ? void 0 : newState.bookForm) && !((_newState_bookForm = newState.bookForm) === null || _newState_bookForm === void 0 ? void 0 : _newState_bookForm.paymentInfo)) {
                newState.bookForm.paymentInfo = initialState.paymentInfo;
            }
            // migrate expectServiceTimes if none
            if ((newState === null || newState === void 0 ? void 0 : newState.bookForm) && !((_newState_bookForm1 = newState.bookForm) === null || _newState_bookForm1 === void 0 ? void 0 : _newState_bookForm1.expectServiceTimes)) {
                newState.bookForm.expectServiceTimes = initialState.expectServiceTimes;
            }
            // migrate selfBookingInfo if none
            if ((newState === null || newState === void 0 ? void 0 : newState.bookForm) && !((_newState_bookForm2 = newState.bookForm) === null || _newState_bookForm2 === void 0 ? void 0 : _newState_bookForm2.selfBookingInfo)) {
                newState.bookForm.selfBookingInfo = initialState.selfBookingInfo;
            }
        });
    }
});
const selectBookForm = (state)=>state.bookForm;
const { initForm , resetForm , fillInForm , clearForm , initCustomizations , setCounty , setDistrict , addOneService , removeOneService , toggleService , replaceExistingServices , setBookedSession , setExpectServiceTimeOne , setExpectServiceTimeTwo , cancelBookedSession , cancelExpectServiceTimeOne , cancelExpectServiceTimeTwo , addOneCustomization , removeOneCustomization , toggleCustomization , replaceExistingCustomizations , changeCustomizationTextValue , changeCustomizationDateValue , removeEmptyCustomizationItem , removeUnselectedCustomizationItem , setBookName , setCustomerBudget , setBookPhone , setBookAddressDetails , setBookAddressHasElevator , setBookEmail , setVat , clearVat , setBookNote , setSiteImages , setCoupon , setPaymentInfo , setVerificationPhone , setStaffNumber , setObjectNo , setSelfBookingReason , setSelfBookingCopyMode , setSelfBookingCopyTimes , setReferrer , addMoveInAddress , removeMoveInAddressByIndex , updateMoveInAddressByIndex , replaceMoveInAddress , setContactDate  } = bookFormSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (bookFormSlice.reducer);


/***/ }),

/***/ 24363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ setAuthFromLocalbondChecked; },
/* harmony export */   "HF": function() { return /* binding */ selectIsFillUserInfoModalChecked; },
/* harmony export */   "HM": function() { return /* binding */ selectNavigateInfo; },
/* harmony export */   "Hh": function() { return /* binding */ setIsFillUserInfoModalChecked; },
/* harmony export */   "MB": function() { return /* binding */ selectVenderSearchRecords; },
/* harmony export */   "OU": function() { return /* binding */ selectAuthFromLocalbondChecked; },
/* harmony export */   "T1": function() { return /* binding */ selectArticleSearchRecords; },
/* harmony export */   "T5": function() { return /* binding */ clearNavigateInfo; },
/* harmony export */   "Wl": function() { return /* binding */ selectPreselectVender; },
/* harmony export */   "YK": function() { return /* binding */ removeAllSearchRecord; },
/* harmony export */   "bE": function() { return /* binding */ setPreselectVender; },
/* harmony export */   "kl": function() { return /* binding */ selectAlbumSearchRecords; },
/* harmony export */   "mT": function() { return /* binding */ clearPreselectVender; },
/* harmony export */   "nb": function() { return /* binding */ setNavigateInfo; },
/* harmony export */   "tk": function() { return /* binding */ addSearchRecord; }
/* harmony export */ });
/* unused harmony export cacheSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79036);
/* harmony import */ var redux_persist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97568);


const initialState = {
    isFillUserInfoModalChecked: false,
    authFromLocalbondChecked: false,
    searchRecord: {
        articleRecords: [],
        albumRecords: [],
        venderRecords: []
    },
    navigateInfo: {
        // 從哪個文章、相簿、廠商etc引導至下單頁
        id: null,
        type: ""
    },
    preselectVender: null
};
const cacheSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "cache",
    initialState: initialState,
    reducers: {
        setIsFillUserInfoModalChecked: (state, action)=>{
            state.isFillUserInfoModalChecked = action.payload;
        },
        setAuthFromLocalbondChecked: (state, action)=>{
            state.authFromLocalbondChecked = action.payload;
        },
        addSearchRecord: (state, action)=>{
            var _state_searchRecord_key;
            const newRecord = action.payload;
            const key = "".concat(newRecord.type, "Records");
            const newRecordExist = (_state_searchRecord_key = state.searchRecord[key]) === null || _state_searchRecord_key === void 0 ? void 0 : _state_searchRecord_key.find((record)=>record.keyword === newRecord.keyword);
            if (!newRecordExist) {
                var _state_searchRecord_key1, _state_searchRecord_key2;
                if (((_state_searchRecord_key1 = state.searchRecord[key]) === null || _state_searchRecord_key1 === void 0 ? void 0 : _state_searchRecord_key1.length) === 5) {
                    state.searchRecord[key].pop();
                }
                (_state_searchRecord_key2 = state.searchRecord[key]) === null || _state_searchRecord_key2 === void 0 ? void 0 : _state_searchRecord_key2.unshift(newRecord);
            }
        },
        removeAllSearchRecord: (state, action)=>{
            state.searchRecord = initialState.searchRecord;
        },
        setNavigateInfo: (state, action)=>{
            const { id , type  } = action.payload;
            state.navigateInfo = {
                id,
                type
            };
        },
        clearNavigateInfo: (state, action)=>{
            state.navigateInfo = initialState.navigateInfo;
        },
        setPreselectVender: (state, action)=>{
            state.preselectVender = action.payload;
        },
        clearPreselectVender: (state, action)=>{
            state.preselectVender = null;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase(redux_persist__WEBPACK_IMPORTED_MODULE_0__.REHYDRATE, (state, action)=>{
            var _newState_cache;
            // TODO: control rehydration here
            // migrate old persist data
            const newState = action.payload;
            if (newState && (newState === null || newState === void 0 ? void 0 : (_newState_cache = newState.cache) === null || _newState_cache === void 0 ? void 0 : _newState_cache.searchRecord) === undefined) {
                newState.cache.searchRecord = initialState.searchRecord;
            }
        });
    }
});
const selectIsFillUserInfoModalChecked = (state)=>state.cache.isFillUserInfoModalChecked;
const selectAuthFromLocalbondChecked = (state)=>state.cache.authFromLocalbondChecked;
const selectArticleSearchRecords = (state)=>state.cache.searchRecord.articleRecords;
const selectAlbumSearchRecords = (state)=>state.cache.searchRecord.albumRecords;
const selectVenderSearchRecords = (state)=>state.cache.searchRecord.venderRecords;
const selectNavigateInfo = (state)=>state.cache.navigateInfo;
const selectPreselectVender = (state)=>state.cache.preselectVender;
const { setIsFillUserInfoModalChecked , setAuthFromLocalbondChecked , addSearchRecord , removeAllSearchRecord , setNavigateInfo , clearNavigateInfo , setPreselectVender , clearPreselectVender  } = cacheSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (cacheSlice.reducer);


/***/ }),

/***/ 67030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ setReservationCode; },
/* harmony export */   "FN": function() { return /* binding */ setServiceClfId; },
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Rw": function() { return /* binding */ setReservationId; },
/* harmony export */   "V2": function() { return /* binding */ setSelfConstructActive; },
/* harmony export */   "XL": function() { return /* binding */ setSelfConstructUserId; },
/* harmony export */   "im": function() { return /* binding */ setSinyiStaffNumber; },
/* harmony export */   "k$": function() { return /* binding */ selectSelfConstruct; }
/* harmony export */ });
/* unused harmony export selfConstructSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const selfConstructSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "selfConstruct",
    // active null 尚未知道模式，true 為自建單模式，false 為非自建單模式
    initialState: {
        active: null
    },
    reducers: {
        setSelfConstructActive: (state, action)=>{
            state.active = action.payload;
        },
        setReservationCode: (state, action)=>{
            state.reservationCode = action.payload;
        },
        setReservationId: (state, action)=>{
            state.reservationId = action.payload;
        },
        setSelfConstructUserId: (state, action)=>{
            state.scUserId = action.payload;
        },
        setUserId: (state, action)=>{
            state.userId = action.payload;
        },
        setSinyiStaffNumber: (state, action)=>{
            state.staffNumber = action.payload;
        },
        setServiceClfId: (state, action)=>{
            state.serviceClfId = action.payload;
        }
    }
});
const selectSelfConstruct = (state)=>state.selfConstruct;
const { setSelfConstructActive , setReservationCode , setReservationId , setSelfConstructUserId , setUserId , setSinyiStaffNumber , setServiceClfId  } = selfConstructSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (selfConstructSlice.reducer);


/***/ }),

/***/ 86377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ clearNotes; },
/* harmony export */   "A9": function() { return /* binding */ setServiceAdminNote; },
/* harmony export */   "Cg": function() { return /* binding */ setWebviewAppVersion; },
/* harmony export */   "E6": function() { return /* binding */ setWebviewDevice; },
/* harmony export */   "Fm": function() { return /* binding */ webviewInitialized; },
/* harmony export */   "NE": function() { return /* binding */ setWebviewName; },
/* harmony export */   "P": function() { return /* binding */ setPriorityVenderIds; },
/* harmony export */   "TN": function() { return /* binding */ selectWebviewName; },
/* harmony export */   "_o": function() { return /* binding */ setWebviewAuthFinished; },
/* harmony export */   "es": function() { return /* binding */ setWebviewOsVersion; },
/* harmony export */   "hn": function() { return /* binding */ selectWebview; },
/* harmony export */   "jT": function() { return /* binding */ setAdditionalNote; },
/* harmony export */   "zL": function() { return /* binding */ setSyStaffCode; }
/* harmony export */ });
/* unused harmony export webviewSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const webviewSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "webview",
    initialState: {
        initialized: false,
        authFinished: false,
        priorityVenderIds: []
    },
    reducers: {
        setWebviewName: (state, action)=>{
            state.name = action.payload;
        },
        setWebviewDevice: (state, action)=>{
            state.device = action.payload;
        },
        setWebviewAppVersion: (state, action)=>{
            state.appVersion = action.payload;
        },
        setWebviewOsVersion: (state, action)=>{
            state.osVersion = action.payload;
        },
        webviewInitialized: (state, action)=>{
            state.initialized = true;
        },
        setWebviewAuthFinished: (state, action)=>{
            state.authFinished = action.payload;
        },
        setSyStaffCode: (state, action)=>{
            state.syStaffCode = action.payload;
        },
        setAdditionalNote: (state, action)=>{
            state.additionalNote = action.payload;
        },
        setServiceAdminNote: (state, action)=>{
            state.serviceAdminNote = action.payload;
        },
        clearNotes: (state, action)=>{
            const result = {
                ...state
            };
            delete result.additionalNote;
            delete result.serviceAdminNote;
            return result;
        },
        setPriorityVenderIds: (state, action)=>{
            state.priorityVenderIds = action.payload;
        }
    }
});
const selectWebview = (state)=>state.webview;
const selectWebviewName = (state)=>{
    var _state_webview;
    return (_state_webview = state.webview) === null || _state_webview === void 0 ? void 0 : _state_webview.name;
};
const { setWebviewName , setWebviewDevice , setWebviewAppVersion , setWebviewOsVersion , webviewInitialized , setWebviewAuthFinished , setSyStaffCode , setAdditionalNote , setServiceAdminNote , clearNotes , setPriorityVenderIds  } = webviewSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (webviewSlice.reducer);


/***/ }),

/***/ 35318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ decryptSelfConstructToken; }
/* harmony export */ });
/* harmony import */ var _decryptText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69021);

const decryptSelfConstructToken = (cipherText)=>{
    return (0,_decryptText__WEBPACK_IMPORTED_MODULE_0__/* .decryptText */ ._)({
        type: "selfConstructedBooking",
        cipherText
    });
};


/***/ }),

/***/ 69021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ decryptText; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const decryptText = (param)=>{
    let { type , cipherText  } = param;
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsPost */ .HR)("/system/decrypt", {
        type,
        cipherText
    }));
};


/***/ }),

/***/ 38875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ logout; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const logout = ()=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsPost */ .HR)("/users/logout"));
};


/***/ }),

/***/ 68056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useLoginData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89289);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53130);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72673);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86700);
/* harmony import */ var store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86377);
/* harmony import */ var utils_helpers_device_info__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2315);








const useStaleMe = function(token) {
    let webview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_5__/* .useCustomSWR */ .LW)(()=>!!token ? [
            "/users/me?".concat((0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)((0,utils_helpers_device_info__WEBPACK_IMPORTED_MODULE_7__/* .getEnvInfoQs */ .Xc)(webview))),
            utils_request__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .ZP.getToken()
        ] : null, utils_request__WEBPACK_IMPORTED_MODULE_4__/* .lsGetWithToken */ .n8, {
        dedupingInterval: 1000 * 60 * 60 * 6
    });
};
const useLoginData = ()=>{
    var _data_me, _data_me1, _data_me2, _data_me3, _data_me4;
    const { token , appId , webviewAuthFinished  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .AuthContext */ .Vo);
    const isAuth = !!token;
    const webview = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectWebview */ .hn);
    const { data , mutate , isLoading , error  } = useStaleMe(token, webview);
    return {
        loggedIn: !!token,
        me: data === null || data === void 0 ? void 0 : data.me,
        error: error && !data,
        token,
        appId,
        mutate,
        isLoading: !webviewAuthFinished || (isAuth ? isLoading : false),
        isServiceAdmin: !isLoading && (data === null || data === void 0 ? void 0 : (_data_me = data.me) === null || _data_me === void 0 ? void 0 : _data_me.role) === "serviceAdmin",
        isVender: !isLoading && (data === null || data === void 0 ? void 0 : (_data_me1 = data.me) === null || _data_me1 === void 0 ? void 0 : _data_me1.role) === "vender",
        isSinyi: !isLoading && ((data === null || data === void 0 ? void 0 : (_data_me2 = data.me) === null || _data_me2 === void 0 ? void 0 : _data_me2.role) === "sinyiIntranet" || (data === null || data === void 0 ? void 0 : (_data_me3 = data.me) === null || _data_me3 === void 0 ? void 0 : _data_me3.role) === "ta3"),
        isCustomer: !isLoading && (data === null || data === void 0 ? void 0 : (_data_me4 = data.me) === null || _data_me4 === void 0 ? void 0 : _data_me4.role) === "customer"
    };
};


/***/ }),

/***/ 53130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ AuthProvider; },
/* harmony export */   "Vo": function() { return /* binding */ AuthContext; },
/* harmony export */   "xY": function() { return /* binding */ SET_ROUTE_KEY; }
/* harmony export */ });
/* unused harmony exports SET_COOKIE_TIME_KEY, initServerSideAuth */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89289);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8100);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12102);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72673);
/* harmony import */ var store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86377);
/* harmony import */ var utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30905);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38875);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35318);
/* harmony import */ var store_selfConstruct_selfConstructSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67030);
/* harmony import */ var store_bookForm_bookFormSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48068);













const DynamicWebviewAuth = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(9477), __webpack_require__.e(9705), __webpack_require__.e(1873)]).then(__webpack_require__.bind(__webpack_require__, 37201)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37201)
            ]
    },
    ssr: false
});
const SET_COOKIE_TIME_KEY = "set-cookie-time";
const SET_ROUTE_KEY = "set-route";
/*
 * Usage: const { token, setToken } = useContext(AuthContext)
 */ const AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    token: "",
    setToken: (token)=>{},
    appId: "",
    webviewAuthFinished: false
});
const AuthProvider = (param)=>{
    let { children , defaultToken  } = param;
    const [initialized, setInitialized] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [cookies, setCookie, removeCookie] = (0,react_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)([
        "token"
    ]);
    const [token, setToken] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(cookies.token || defaultToken || "");
    const [appId, setAppId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(cookies.appId);
    const webview = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectWebview */ .hn);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const logoutClient = async ()=>{
        setToken("");
        await router.push("/");
        dispatch((0,store_selfConstruct_selfConstructSlice__WEBPACK_IMPORTED_MODULE_9__/* .setSelfConstructActive */ .V2)(false));
        dispatch((0,store_bookForm_bookFormSlice__WEBPACK_IMPORTED_MODULE_10__/* .clearForm */ .ou)());
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("isSelfConstruct");
        // remove old service data
        localStorage.removeItem("domesticServiceAddress");
        sessionStorage.removeItem("syDomesticService");
        localStorage.removeItem("isLogin");
    };
    const isCheckTokenRoute = [
        "/profile",
        "/complete-profile",
        "/credit-card",
        "/reservation",
        "/coupon",
        "/recommend-discount",
        "/setting",
        "/reservation/[reservationId]/[orderStatus]"
    ];
    const selfConstructRoute = [
        "/self-construct-singlereservation"
    ];
    // Self Construct login only in specify page
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const loadDecryptScToken = async ()=>{
            const { scCode  } = router.query;
            const logoutExistClient = async ()=>{
                if (!localStorage.getItem("refreshToken")) return;
                const [result, error] = await (0,utils_api__WEBPACK_IMPORTED_MODULE_12__/* .logout */ .k)();
                if (!error) {
                    localStorage.removeItem("isLogin");
                    localStorage.removeItem("refreshToken");
                }
            };
            if (scCode) {
                await logoutExistClient();
                const [data, error] = await (0,utils_api__WEBPACK_IMPORTED_MODULE_13__/* .decryptSelfConstructToken */ .G)(scCode);
                if (error) {
                    console.error(error.message);
                } else {
                    const { text: scToken  } = data;
                    handleSetToken(scToken);
                    localStorage.setItem("isLogin", true);
                    localStorage.setItem("isSelfConstruct", true);
                }
            }
        };
        if (router.isReady && selfConstructRoute.includes(router.pathname)) {
            loadDecryptScToken();
        }
    }, [
        router.isReady,
        router.pathname
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (router.isReady && !selfConstructRoute.includes(router.pathname)) {
            const isSelfConstruct = localStorage.getItem("isSelfConstruct");
            if (isSelfConstruct) logoutClient();
        }
    }, [
        router.isReady,
        router.pathname
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!webview.authFinished) {
            return;
        }
        // update SWR cache and cookie using updated token
        if (!token) {
            (0,swr__WEBPACK_IMPORTED_MODULE_5__/* .mutate */ .JG)("/users/me", null, false);
            removeCookie("token", {
                path: "/"
            });
            if (isCheckTokenRoute.includes(router.pathname) && !localStorage.getItem("isLogin")) {
                localStorage.setItem(SET_ROUTE_KEY, router.asPath);
                router.push("/login");
                return;
            }
        } else {
            if (initialized) {
                (0,swr__WEBPACK_IMPORTED_MODULE_5__/* .mutate */ .JG)("/users/me");
                setCookieToken(token);
            }
        }
        setInitialized(true);
    }, [
        token,
        webview === null || webview === void 0 ? void 0 : webview.authFinished,
        router.pathname
    ]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const [webviewAuth, setWebviewAuth] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.initialized) && !(webview === null || webview === void 0 ? void 0 : webview.authFinished) && router.isReady) {
            if (!!(webview === null || webview === void 0 ? void 0 : webview.name)) {
                setWebviewAuth(true);
            } else {
                utils_request__WEBPACK_IMPORTED_MODULE_6__/* ["default"].setToken */ .ZP.setToken(token);
                dispatch((0,store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__/* .setWebviewAuthFinished */ ._o)(true));
            }
        }
    }, [
        webview === null || webview === void 0 ? void 0 : webview.initialized,
        router.isReady
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // init appId if not exist
        if ((webview === null || webview === void 0 ? void 0 : webview.initialized) && (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && !appId) {
            const newAppId = (0,utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .uuidv4 */ .k$)();
            setAppId(newAppId);
            setCookie("appId", newAppId, {
                path: "/",
                maxAge: 630720000
            });
        }
    }, [
        webview === null || webview === void 0 ? void 0 : webview.initialized
    ]);
    const setCookieToken = (token)=>{
        setCookie("token", token, {
            path: "/",
            maxAge: 630720000
        });
        localStorage.setItem(SET_COOKIE_TIME_KEY, Date.now());
    };
    const handleSetToken = function(token, refreshToken) {
        let resetAppId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        // reset appId if logged out
        if (!token && resetAppId) {
            const newAppId = (0,utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .uuidv4 */ .k$)();
            setAppId((0,utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .uuidv4 */ .k$)());
            setCookie("appId", newAppId, {
                path: "/",
                maxAge: 630720000
            });
        }
        if (token && refreshToken) {
            localStorage.setItem("refreshToken", refreshToken);
        }
        utils_request__WEBPACK_IMPORTED_MODULE_6__/* ["default"].setToken */ .ZP.setToken(token);
        setCookieToken(token);
        /**
     * Note: setToken 必須要在 RequestCore.setToken 之後，
     * 否則用 token 觸發事件後，但是取 RequestCore.getToken 有可能會取到舊的
     */ setToken(token);
    };
    const value = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return {
            token: (webview === null || webview === void 0 ? void 0 : webview.authFinished) ? token : "",
            setToken: handleSetToken,
            appId,
            webviewAuthFinished: webview === null || webview === void 0 ? void 0 : webview.authFinished
        };
    }, [
        token,
        appId,
        webview.authFinished
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AuthContext.Provider, {
        value: value,
        children: [
            children,
            !!webviewAuth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicWebviewAuth, {
                token: token,
                setToken: handleSetToken,
                appId: appId,
                setAppId: setAppId,
                setWebviewAuth: setWebviewAuth
            })
        ]
    });
};
/*
 * Used in getServerSideProps
 * Usage: const { token, isAuth } = initServerSideAuth(req)
 */ //
const initServerSideAuth = (req)=>{
    var _req_headers_cookie;
    const token = ((_req_headers_cookie = req.headers.cookie) === null || _req_headers_cookie === void 0 ? void 0 : _req_headers_cookie.token) || "";
    RequestCore.setToken(token);
    return {
        token,
        isAuth: !!token
    };
};


/***/ }),

/***/ 65129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Br": function() { return /* binding */ getFromCookie; },
/* harmony export */   "nJ": function() { return /* binding */ removeCookie; },
/* harmony export */   "pb": function() { return /* binding */ setToCookie; }
/* harmony export */ });
/*
 * manipulate cookie outside react
 */ function getFromCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " "){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function setToCookie(cname, cvalue, expires) {
    document.cookie = "".concat(cname, "=").concat(cvalue, ";expires=").concat(expires, ";path=/;");
}
function removeCookie(cname) {
    document.cookie = "".concat(cname, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;");
}


/***/ }),

/***/ 2315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ getSinyiDeviceInfo; },
/* harmony export */   "Xc": function() { return /* binding */ getEnvInfoQs; },
/* harmony export */   "bz": function() { return /* binding */ getEnvInfo; },
/* harmony export */   "z5": function() { return /* binding */ getSinyiDeviceInfoQs; }
/* harmony export */ });
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73221);

const getOS = ()=>{
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        return "Windows";
    }
    if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        return "Windows";
    }
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const MAC = /macintosh|mac os x/i.test(navigator.userAgent) && !window.MSStream;
    const android = /Android/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
        return "ios";
    }
    if (MAC) {
        return "MAC";
    }
    if (android) {
        return "Android";
    }
    return "Others";
};
const getDeviceSizeType = ()=>{
    const agent = navigator.userAgent;
    if (/iPad|tablet/.test(agent)) {
        return "tablet";
    }
    if (/iPhone|iPad|Android/.test(agent)) {
        return "mobile";
    }
    const laptopReg = /macintosh|mac os x|win32|wow32|win64|wow64/;
    if (laptopReg.test(agent.toLowerCase())) {
        return "desktop";
    }
    console.warn("device size not detected");
    return "mobile";
};
const isEdge = ()=>{
    var _navigator_userAgentData;
    if (navigator.userAgent.indexOf("edge") > -1) {
        return true;
    }
    const brands = ((_navigator_userAgentData = navigator.userAgentData) === null || _navigator_userAgentData === void 0 ? void 0 : _navigator_userAgentData.brands) || [];
    if (brands.some((brandPair)=>brandPair.brand === "Microsoft Edge")) {
        return true;
    }
    return false;
};
const getBrowser = ()=>{
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) !== -1) {
        return "opera";
    } else if (isEdge()) {
        return "Edge";
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
        return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
        return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        return "Firefox";
    } else if (navigator.userAgent.indexOf("MSIE") != -1 || !!document.documentMode === true) {
        return "IE";
    } else {
        return "others";
    }
};
const getSinyiDeviceInfo = (webview)=>{
    const os = getOS();
    const deviceSizeType = getDeviceSizeType();
    let apType = "APP";
    if ((webview === null || webview === void 0 ? void 0 : webview.name) === "sinyiWeb") {
        if (deviceSizeType === "desktop") {
            apType = "DesktopSite";
        } else {
            apType = "MobileSite";
        }
    } else if ((webview === null || webview === void 0 ? void 0 : webview.name) !== "sinyiApp") {
        console.warn("invalid webview ".concat(webview === null || webview === void 0 ? void 0 : webview.name));
    }
    const browser = getBrowser();
    const sinyiOSTypeMap = {
        Android: 1,
        ios: 2,
        Windows: 3,
        MAC: 4,
        Linux: 5,
        Others: 6
    };
    const sinyiDeviceTypeMap = {
        mobile: 1,
        tablet: 2,
        desktop: 3
    };
    const sinyiApTypeMap = {
        APP: 1,
        MobileSite: 2,
        DesktopSite: 3,
        Scheduling: 4
    };
    const sinyiBrowserMap = {
        none: 1,
        Chrome: 2,
        IE: 3,
        Firefox: 4,
        Safari: 5,
        Opera: 6,
        Edge: 7,
        others: 8
    };
    return {
        osType: sinyiOSTypeMap[os],
        deviceType: sinyiDeviceTypeMap[deviceSizeType],
        apType: sinyiApTypeMap[apType],
        browser: sinyiBrowserMap[apType === "APP" ? "none" : browser],
        appVersion: (webview === null || webview === void 0 ? void 0 : webview.appVersion) || config_constants__WEBPACK_IMPORTED_MODULE_0__/* .APP_VERSION */ .Ji
    };
};
const getEnvInfo = (webview)=>{
    return {
        appVersion: (webview === null || webview === void 0 ? void 0 : webview.appVersion) || config_constants__WEBPACK_IMPORTED_MODULE_0__/* .APP_VERSION */ .Ji,
        browserName: getBrowser().toLowerCase(),
        browserVersion: navigator ? navigator.userAgent : null,
        deviceModel: navigator ? navigator.platform : null,
        deviceType: (webview === null || webview === void 0 ? void 0 : webview.device) || "web",
        osName: getOS(),
        osVersion: (webview === null || webview === void 0 ? void 0 : webview.osVersion) || "",
        origin: (webview === null || webview === void 0 ? void 0 : webview.name) || "lsWeb"
    };
};
// get env info for query string keys witch starts with underline
const convertToQs = (envInfo)=>{
    const entries = Object.entries(envInfo).map((param)=>{
        let [key, value] = param;
        return [
            "_".concat(key),
            encodeURIComponent(value)
        ];
    });
    return Object.fromEntries(entries);
};
const getEnvInfoQs = (webview)=>convertToQs(getEnvInfo(webview));
const getSinyiDeviceInfoQs = (webview)=>convertToQs(getSinyiDeviceInfo(webview));


/***/ }),

/***/ 30905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": function() { return /* binding */ isAddressValidRegionForRelocationService; },
/* harmony export */   "Hz": function() { return /* binding */ numToCurrency; },
/* harmony export */   "N9": function() { return /* binding */ convertContactAddress; },
/* harmony export */   "_r": function() { return /* binding */ encodeByAESCBC; },
/* harmony export */   "eC": function() { return /* binding */ safeDecodeURIComponent; },
/* harmony export */   "k$": function() { return /* binding */ uuidv4; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; },
/* harmony export */   "wb": function() { return /* binding */ hasVenderAboutContent; },
/* harmony export */   "zR": function() { return /* binding */ downloadCanvasAsImage; }
/* harmony export */ });
/* unused harmony export downloadFile */
const aesjs = __webpack_require__(78826);
const uuidv4 = ()=>{
    return ([
        1e7
    ] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};
const numToCurrency = (num)=>{
    try {
        num = num.toLocaleString("en");
    } catch (e) {}
    return num;
};
const copyToClipboard = (text)=>{
    try {
        setTimeout(async ()=>await navigator.clipboard.writeText(text));
    } catch (err) {
        const copyText = document.createElement("textarea");
        document.body.appendChild(copyText);
        copyText.value = text;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        /* For mobile devices */ document.execCommand("copy");
        copyText.remove();
    }
};
/**
 * 下載檔案
 * @param {*} dataUrl
 * @param {*} filename 若不指定副檔名，會自動偵測
 */ const downloadFile = (dataUrl, fileName)=>{
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = fileName;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
/**
 * 下載 Canvas 並存成圖片
 * @param {*} canvasEl
 * @param {*} fileName 若不指定副檔名，會自動偵測
 */ const downloadCanvasAsImage = (canvasEl, fileName)=>{
    downloadFile(canvasEl.toDataURL(), fileName);
};
const convertContactAddress = (contactAddress)=>{
    const source = {
        ...contactAddress
    } // clone
    ;
    const fields = [
        "district",
        "village",
        "road",
        "lane",
        "alley",
        "number",
        "suffixNumber",
        "subNumber",
        "floor",
        "suffixFloorNumber",
        "unitNumber"
    ];
    // set null & undefined to empty string
    fields.forEach((field)=>{
        source[field] = source[field] || "";
    });
    let number = source.number;
    if (number) {
        number += source.suffixNumber && "-".concat(source.suffixNumber);
        number += source.subNumber ? "號之".concat(source.subNumber) : "號";
    }
    let floor = source.floor;
    if (floor) {
        floor += source.suffixFloorNumber && "-".concat(source.suffixFloorNumber);
        floor += source.unitNumber ? "樓之".concat(source.unitNumber) : "樓";
    }
    return {
        county: source.county,
        district: source.district,
        details: source.village + source.road + (source.lane ? source.lane + "巷" : "") + (source.alley ? source.alley + "弄" : "") + number + floor
    };
};
const isAddressValidRegionForRelocationService = (address, validRegions)=>{
    var _region_districts, _region_districts1;
    const region = validRegions.find((region)=>{
        return region.county === (address === null || address === void 0 ? void 0 : address.county);
    });
    const countyValid = !!region;
    const districtValid = !(region === null || region === void 0 ? void 0 : (_region_districts = region.districts) === null || _region_districts === void 0 ? void 0 : _region_districts.length) || (region === null || region === void 0 ? void 0 : (_region_districts1 = region.districts) === null || _region_districts1 === void 0 ? void 0 : _region_districts1.find((district)=>{
        return district === (address === null || address === void 0 ? void 0 : address.district);
    }));
    return countyValid && districtValid;
};
const hasVenderAboutContent = (aboutData)=>{
    var _aboutData_introduction, _aboutData_introduction_content, _aboutData_achievements, _aboutData_teamMembers, _aboutData_certifications, _aboutData_licenses;
    return Boolean((aboutData === null || aboutData === void 0 ? void 0 : (_aboutData_introduction = aboutData.introduction) === null || _aboutData_introduction === void 0 ? void 0 : (_aboutData_introduction_content = _aboutData_introduction.content) === null || _aboutData_introduction_content === void 0 ? void 0 : _aboutData_introduction_content.trim()) || (aboutData === null || aboutData === void 0 ? void 0 : (_aboutData_achievements = aboutData.achievements) === null || _aboutData_achievements === void 0 ? void 0 : _aboutData_achievements.length) || (aboutData === null || aboutData === void 0 ? void 0 : (_aboutData_teamMembers = aboutData.teamMembers) === null || _aboutData_teamMembers === void 0 ? void 0 : _aboutData_teamMembers.length) || (aboutData === null || aboutData === void 0 ? void 0 : (_aboutData_certifications = aboutData.certifications) === null || _aboutData_certifications === void 0 ? void 0 : _aboutData_certifications.length) || (aboutData === null || aboutData === void 0 ? void 0 : (_aboutData_licenses = aboutData.licenses) === null || _aboutData_licenses === void 0 ? void 0 : _aboutData_licenses.length));
};
//用AES的CBC模式加密並輸出十六進位格式
const encodeByAESCBC = async (value)=>{
    try {
        const res = await fetch("/api/encodebyaescbc?value=".concat(encodeURIComponent(value)));
        const { encryptedHex  } = await res.json();
        return encryptedHex;
    } catch (error) {
        console.error("encodeByAESCBC error", error);
        return null;
    }
};
// 建立一個較安全的 URI 解碼函式
const safeDecodeURIComponent = (value)=>{
    if (!value) return "";
    try {
        return decodeURIComponent(value);
    } catch (e) {
        // 若解碼失敗（e.g. 遇到無效的 '%' 字元）則直接使用原始 value 進行後續處理
        if (e instanceof URIError) {
            return value // 解碼失敗時，回傳原始值
            ;
        }
        throw e;
    }
};


/***/ }),

/***/ 86700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KU": function() { return /* binding */ useCustomSWRInfinite; },
/* harmony export */   "LW": function() { return /* binding */ useCustomSWR; }
/* harmony export */ });
/* unused harmony export useStaleSWR */
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44593);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);



// 1 export isLoading flag
// 2 prevent revalidate on component mount with fallback data
const enhanceSWR = (useEnhancedSWR)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const [dataArg, fetcherArg, configArg] = args;
        const swrConfig = Object.assign({}, configArg || {}, {
            revalidateIfStale: false
        });
        const { data , error , ...rest } = useEnhancedSWR(dataArg, fetcherArg, swrConfig);
        const isLoading = !data && !error;
        return {
            data,
            error,
            isLoading,
            ...rest
        };
    };
const useCustomSWR = enhanceSWR(swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP);
const useCustomSWRInfinite = enhanceSWR(swr_infinite__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP);
// programmatically read the key string from various types of `key`
// (string, function and array)
// useStaleSWR use the result of it to determine fetch from remote
// or use cache
const getLCKeyString = (key)=>{
    if (typeof key === "function") {
        return key();
    }
    if (typeof key === "object") {
        // array
        const [path, data] = key;
        return path + (data ? "" : "?".concat(stringify(data)));
    }
    return key // string
    ;
};
// Not refetching data automatically
const useStaleSWR = function(key, fetcher) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const revalidationOptions = {
        revalidateIfStale: false,
        revalidateOnFocus: false
    };
    return useCustomSWR(key, fetcher, {
        ...options,
        ...revalidationOptions
    });
};


/***/ }),

/***/ 11634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gz": function() { return /* binding */ enableNativeHeaderNavBack; },
/* harmony export */   "Iy": function() { return /* binding */ retrieveToken; },
/* harmony export */   "L9": function() { return /* binding */ loadAuthDataFromLocalbondNative; },
/* harmony export */   "MO": function() { return /* binding */ goToReservationDetail; },
/* harmony export */   "P5": function() { return /* binding */ invokeNativeAPP; },
/* harmony export */   "PP": function() { return /* binding */ enableNativeHeaderSearch; },
/* harmony export */   "QL": function() { return /* binding */ enableNativeHeaderMainTabs; },
/* harmony export */   "S3": function() { return /* binding */ retrieveAppId; },
/* harmony export */   "UP": function() { return /* binding */ shareUrlFromNative; },
/* harmony export */   "WU": function() { return /* binding */ closeWebView; },
/* harmony export */   "Wn": function() { return /* binding */ setRefreshTokenToNative; },
/* harmony export */   "fj": function() { return /* binding */ setTokenToNative; },
/* harmony export */   "fo": function() { return /* binding */ setStopReminderValidateDealCustomerToNative; },
/* harmony export */   "gn": function() { return /* binding */ enableDragReload; },
/* harmony export */   "mj": function() { return /* binding */ retrieveRefreshToken; },
/* harmony export */   "mp": function() { return /* binding */ setApplePayResult; },
/* harmony export */   "p2": function() { return /* binding */ checkNativeApplePayAvailable; },
/* harmony export */   "vD": function() { return /* binding */ getApplePayToken; },
/* harmony export */   "wt": function() { return /* binding */ retrieveStopReminderValidateDealCustomer; },
/* harmony export */   "y6": function() { return /* binding */ copyTextFromNative; }
/* harmony export */ });
/* unused harmony export presentMessenger */
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27601);
/*
 * retrieveToken: 從app拿取token
 * retrieveRefreshToken: 從app拿取refresh token
 * setTokenToNative: 將token更新至app
 * goToReservationDetail: 關掉webview進入native訂單頁面
 * presentMessenger: 開啟native客服對話
 * logFirebaseEvent: 呼叫App發送firebase data
 */ 
const invokeNativeAPP = (apiName, data)=>{
    if (false) {}
    const string = (0,lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data) || typeof data === "string" ? data : JSON.stringify(data);
    try {
        return window.webkit.messageHandlers[apiName].postMessage(string) // ios
        ;
    } catch (err) {
        var _window_callback;
        // android
        if ((_window_callback = window.callback) === null || _window_callback === void 0 ? void 0 : _window_callback[apiName]) {
            if (string) {
                return window.callback[apiName](string);
            } else {
                return window.callback[apiName]();
            }
        }
    }
};
// return value is string
const readFromNative = (apiName, options)=>{
    var _window_callback;
    const { data , timeout  } = options || {};
    if ((_window_callback = window.callback) === null || _window_callback === void 0 ? void 0 : _window_callback[apiName]) {
        // run into this block when android callback exist
        return invokeNativeAPP(apiName, data);
    } else {
        // ios
        return new Promise((resolve)=>{
            const callbackNameWithoutWindow = "__".concat(apiName, "Callback");
            window[callbackNameWithoutWindow] = (result)=>resolve(result);
            const callbackName = "window.".concat(callbackNameWithoutWindow);
            const dataSend = data !== undefined ? {
                data,
                callbackName
            } : callbackName;
            invokeNativeAPP(apiName, dataSend);
            // 避免未實作API永遠block住，設定timeout
            setTimeout(()=>resolve(), (timeout || 20) * 1000);
        });
    }
};
// return value is JSON Object
const readJsonFromNative = async (apiName, options)=>{
    const result = await readFromNative(apiName, options);
    // 若為無法 parse 的值則避免解析錯誤並回傳 null 讓後續函式接手判斷
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(result) || result === "") return null;
    try {
        return JSON.parse(result);
    } catch (e) {
        console.error("readJsonFromNative parse error:", e, "original text:", result);
        return null;
    }
};
const retrieveToken = ()=>readFromNative("getToken");
const retrieveRefreshToken = ()=>readFromNative("getRefreshToken");
const retrieveAppId = ()=>readFromNative("getAppId");
const retrieveStopReminderValidateDealCustomer = ()=>readFromNative("getStopReminderValidateDealCustomer");
const setStopReminderValidateDealCustomerToNative = (bool)=>invokeNativeAPP("setStopReminderValidateDealCustomer", bool);
const getApplePayToken = (amount)=>readFromNative("getApplePayToken", {
        data: amount,
        timeout: 15 * 60
    });
const setApplePayResult = (bool)=>invokeNativeAPP("setApplePayResult", bool);
const checkNativeApplePayAvailable = ()=>readJsonFromNative("getCanMakePaymentsWithApplePay");
const setTokenToNative = (token)=>invokeNativeAPP("setToken", token);
const setRefreshTokenToNative = (token)=>{
    invokeNativeAPP("setRefreshToken", token);
};
const goToReservationDetail = (reservationId, reservationListMode)=>{
    if (reservationListMode === "stateUnordered") {
        invokeNativeAPP("goTo", {
            page: "unorderedReservationDetail",
            param: {
                unorderedReservationId: reservationId
            }
        });
    } else {
        invokeNativeAPP("goTo", {
            page: "reservationDetail",
            param: {
                reservationId
            }
        });
    }
};
const presentMessenger = ()=>invokeNativeAPP("presentMessenger");
const closeWebView = ()=>invokeNativeAPP("closeWebView", true);
const loadAuthDataFromLocalbondNative = ()=>{
    return new Promise((resolve)=>{
        window.__setCodedData = (token)=>resolve(token);
        invokeNativeAPP("getCodedData00", "window.__setCodedData");
    });
};
const enableDragReload = ()=>invokeNativeAPP("allowReload", false);
const enableNativeHeaderMainTabs = (bool)=>invokeNativeAPP("showWebViewMainTabs", bool);
const enableNativeHeaderNavBack = (bool)=>invokeNativeAPP("showBackButton", bool);
const enableNativeHeaderSearch = (bool)=>invokeNativeAPP("showSearchButton", bool);
const shareUrlFromNative = (content, url)=>{
    invokeNativeAPP("shareUrl", {
        content,
        url
    });
};
const copyTextFromNative = (text)=>invokeNativeAPP("copy", text);


/***/ }),

/***/ 72673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ev": function() { return /* binding */ safeAwait; },
/* harmony export */   "HR": function() { return /* binding */ lsPost; },
/* harmony export */   "OL": function() { return /* binding */ lsPut; },
/* harmony export */   "UY": function() { return /* binding */ lsGet; },
/* harmony export */   "jC": function() { return /* binding */ lsAppGet; },
/* harmony export */   "n8": function() { return /* binding */ lsGetWithToken; },
/* harmony export */   "v3": function() { return /* binding */ lsDelete; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85340);
/* harmony import */ var _swc_helpers_src_class_static_private_field_spec_set_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54150);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73221);
/* harmony import */ var utils_helpers_device_info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2315);
/* harmony import */ var utils_helpers_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65129);
/* harmony import */ var utils_native_notifier__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11634);









class RequestCore {
    // Should only be used by swr queries
    static getToken(token) {
        return (0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, RequestCore, _token);
    }
    static setToken(token) {
        (0,_swc_helpers_src_class_static_private_field_spec_set_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, RequestCore, _token, token);
    }
    static hasToken() {
        return !!(0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, RequestCore, _token);
    }
    // set `authorization` to the options field of request methods(ex. lsGet)
    // for overwriting it in specified conditions if needed.
    static genHeaders() {
        let headers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, RequestCore, _token) ? {
            authorization: "Bearer ".concat((0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, RequestCore, _token)),
            ...headers
        } : headers;
    }
    // used by swr queries
    static genHeadersWithToken(token) {
        let headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return token ? {
            authorization: "Bearer ".concat(token),
            ...headers
        } : headers;
    }
}
// All living sinyi queries use this token,
var _token = {
    writable: true,
    value: null
};
/* harmony default export */ __webpack_exports__["ZP"] = (RequestCore);
// Check HTTP code from living sinyi API
const lsCheckHTTPStatus = (response, fetchArgs)=>{
    if (response.status >= 200 && response.status < 400) {
        return response;
    } else if (response.status === 401) {
        return UnauthorizeHandler.handleTokenRefresh(response.status, fetchArgs);
    }
    const error = new Error(response.statusText);
    error._response = response;
    throw error;
};
// Check living sinyi response successfully
const lsCheckResponseSuccess = (data, fetchArgs)=>{
    var _data_error;
    if (data === null || data === void 0 ? void 0 : data.ok) {
        return data === null || data === void 0 ? void 0 : data.result;
    } else if ((data === null || data === void 0 ? void 0 : (_data_error = data.error) === null || _data_error === void 0 ? void 0 : _data_error.code) === 401) {
        return UnauthorizeHandler.handleTokenRefresh(data.error.code, fetchArgs);
    }
    const error = new Error(data === null || data === void 0 ? void 0 : data.msg);
    error._response = data.error;
    throw error;
};
const lsRequest = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return fetch(...args).then((response)=>lsCheckHTTPStatus(response, args)).then((response)=>response.json()).then((response)=>lsCheckResponseSuccess(response, args));
};
// avoid try/catch handling by returning [data, error] array
// Usage: const [data, error] = await safeAwait(promise)
const nativeExceptions = [
    EvalError,
    RangeError,
    ReferenceError,
    SyntaxError,
    TypeError,
    URIError
].filter((except)=>typeof except === "function");
function throwNative(error) {
    for (const Exception of nativeExceptions){
        if (error instanceof Exception) throw error;
    }
}
const safeAwait = (promise)=>promise.then((data)=>{
        if (data instanceof Error) {
            throwNative(data);
            return [
                data
            ];
        }
        return [
            data
        ];
    }).catch((error)=>{
        throwNative(error);
        return [
            undefined,
            error
        ];
    });
const getMethod = (domain, core)=>{
    return (path, data, options)=>{
        const qs = !!data && (0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(data);
        const headers = (core === null || core === void 0 ? void 0 : core.genHeaders(options === null || options === void 0 ? void 0 : options.headers)) || {};
        const isServer = "object" === "undefined";
        return lsRequest("".concat(domain).concat(path) + (qs ? "?".concat(qs) : ""), {
            headers: isServer ? {
                ...headers,
                "User-Agent": "LivingLife/".concat(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_VERSION */ .Ji)
            } : {
                ...headers
            }
        });
    };
};
// Used by seansitive data hooks
const getMethodWithToken = (domain, core)=>{
    return (path, token, data, options)=>{
        const headers = (core === null || core === void 0 ? void 0 : core.genHeadersWithToken(token, options === null || options === void 0 ? void 0 : options.headers)) || {};
        const isServer = "object" === "undefined";
        return lsRequest("".concat(domain).concat(path) + (data ? "?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(data)) : ""), {
            headers: isServer ? {
                ...headers,
                "User-Agent": "LivingLife/".concat(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_VERSION */ .Ji)
            } : {
                ...headers
            }
        });
    };
};
const postMethod = (domain, core)=>{
    return function(path) {
        let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
        return lsRequest(domain + path + ((options === null || options === void 0 ? void 0 : options.qs) ? "?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(options === null || options === void 0 ? void 0 : options.qs)) : ""), {
            method: "POST",
            headers: (options === null || options === void 0 ? void 0 : options.uploadFile) ? (core === null || core === void 0 ? void 0 : core.genHeaders(options === null || options === void 0 ? void 0 : options.headers)) || {} : {
                "Content-Type": "application/json",
                ...(core === null || core === void 0 ? void 0 : core.genHeaders(options === null || options === void 0 ? void 0 : options.headers)) || {}
            },
            body: (options === null || options === void 0 ? void 0 : options.uploadFile) ? data : JSON.stringify(data)
        });
    };
};
const putMethod = (domain, core)=>{
    return function(path) {
        let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
        return lsRequest(domain + path + ((options === null || options === void 0 ? void 0 : options.qs) ? "?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(options === null || options === void 0 ? void 0 : options.qs)) : ""), {
            method: "PUT",
            headers: {
                ...(core === null || core === void 0 ? void 0 : core.genHeaders(options === null || options === void 0 ? void 0 : options.headers)) || {},
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
    };
};
const deleteMethod = (domain, core)=>{
    return (path, data, options)=>{
        return lsRequest("".concat(domain).concat(path) + (data ? "?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(data)) : ""), {
            method: "DELETE",
            headers: (core === null || core === void 0 ? void 0 : core.genHeaders(options === null || options === void 0 ? void 0 : options.headers)) || {}
        });
    };
};
const lsGet = getMethod(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_API_DOMAIN */ .SB, RequestCore);
const lsGetWithToken = getMethodWithToken(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_API_DOMAIN */ .SB, RequestCore);
const lsPost = postMethod(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_API_DOMAIN */ .SB, RequestCore);
const lsPut = putMethod(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_API_DOMAIN */ .SB, RequestCore);
const lsDelete = deleteMethod(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_API_DOMAIN */ .SB, RequestCore);
const lsAppGet = getMethod(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_APP_DOMAIN */ ._8);
class UnauthorizeHandler {
}
var _isRefreshing = {
    writable: true,
    value: false
};
var _waitingWueue = {
    writable: true,
    value: []
};
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(UnauthorizeHandler, "pushToWaitingQueue", (promiseObj)=>{
    (0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(UnauthorizeHandler, UnauthorizeHandler, _waitingWueue).push(promiseObj);
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(UnauthorizeHandler, "processWaitingQueue", (param)=>{
    let { error , token  } = param;
    (0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(UnauthorizeHandler, UnauthorizeHandler, _waitingWueue).forEach((param)=>{
        let { resolve , reject  } = param;
        if (error) {
            reject(error);
        } else {
            resolve(token);
        }
    });
    (0,_swc_helpers_src_class_static_private_field_spec_set_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(UnauthorizeHandler, UnauthorizeHandler, _waitingWueue, []);
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(UnauthorizeHandler, "handleTokenRefresh", async (code, fetchArgs)=>{
    if (false) {}
    const [reqUrl, reqOptions] = fetchArgs;
    // 檢查是否已登入且存有refresh token
    let refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
        var _reqOptions_headers;
        const originalAuth = reqOptions === null || reqOptions === void 0 ? void 0 : (_reqOptions_headers = reqOptions.headers) === null || _reqOptions_headers === void 0 ? void 0 : _reqOptions_headers["authorization"];
        if (!originalAuth) {
            throw new Error("尚未登入") // 從未登入
            ;
        } else {
            UnauthorizeHandler.handleRefreshFailed() // 有token卻沒有refresh token
            ;
        }
    }
    if (code === 401) {
        if ((0,_swc_helpers_src_class_static_private_field_spec_get_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(UnauthorizeHandler, UnauthorizeHandler, _isRefreshing)) {
            // refresh中，將request放入queue等待完成
            return new Promise((resolve, reject)=>{
                UnauthorizeHandler.pushToWaitingQueue({
                    resolve,
                    reject
                });
            }).then((token)=>{
                UnauthorizeHandler.setAuthToFetchArguments(fetchArgs, token);
                return lsRequest(...fetchArgs);
            }).catch((error)=>Promise.reject(error));
        } else {
            (0,_swc_helpers_src_class_static_private_field_spec_set_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(UnauthorizeHandler, UnauthorizeHandler, _isRefreshing, true);
            return new Promise((resolve, reject)=>{
                fetch("".concat(config_constants__WEBPACK_IMPORTED_MODULE_1__/* .LS_API_DOMAIN */ .SB, "/users/refreshToken"), {
                    method: "POST",
                    headers: {
                        "Content-Type": "Application/json"
                    },
                    body: JSON.stringify({
                        refreshToken,
                        origin: "lsWeb",
                        envInfo: (0,utils_helpers_device_info__WEBPACK_IMPORTED_MODULE_2__/* .getEnvInfo */ .bz)()
                    })
                }).then(async (response)=>{
                    const data = await response.json();
                    if (response.status === 200 && data.ok) {
                        var _data_result, _data_result1;
                        const newToken = data === null || data === void 0 ? void 0 : (_data_result = data.result) === null || _data_result === void 0 ? void 0 : _data_result._id;
                        const newRefreshToken = data === null || data === void 0 ? void 0 : (_data_result1 = data.result) === null || _data_result1 === void 0 ? void 0 : _data_result1.refreshToken;
                        (0,utils_helpers_cookie__WEBPACK_IMPORTED_MODULE_6__/* .setToCookie */ .pb)("token", newToken);
                        RequestCore.setToken(newToken);
                        localStorage.setItem("refreshToken", newRefreshToken);
                        // set token to native if it's lsApp
                        if (/webview=lsApp/.test(location.href)) {
                            (0,utils_native_notifier__WEBPACK_IMPORTED_MODULE_7__/* .setTokenToNative */ .fj)(newToken);
                            (0,utils_native_notifier__WEBPACK_IMPORTED_MODULE_7__/* .setRefreshTokenToNative */ .Wn)(newRefreshToken);
                        }
                        UnauthorizeHandler.setAuthToFetchArguments(fetchArgs, newToken);
                        UnauthorizeHandler.processWaitingQueue({
                            token: newToken
                        });
                        resolve(lsRequest(...fetchArgs));
                    } else {
                        UnauthorizeHandler.handleRefreshFailed();
                    }
                }).catch((error)=>{
                    UnauthorizeHandler.processWaitingQueue({
                        error,
                        token: null
                    });
                    UnauthorizeHandler.handleRefreshFailed();
                    reject(error);
                }).then(()=>{
                    (0,_swc_helpers_src_class_static_private_field_spec_set_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(UnauthorizeHandler, UnauthorizeHandler, _isRefreshing, false);
                });
            });
        }
    }
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(UnauthorizeHandler, "setAuthToFetchArguments", function() {
    let fetchArgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], token = arguments.length > 1 ? arguments[1] : void 0;
    var _fetchArgs_;
    fetchArgs[1] = (fetchArgs === null || fetchArgs === void 0 ? void 0 : fetchArgs[1]) || {};
    fetchArgs[1].headers = (fetchArgs === null || fetchArgs === void 0 ? void 0 : (_fetchArgs_ = fetchArgs[1]) === null || _fetchArgs_ === void 0 ? void 0 : _fetchArgs_.headers) || {};
    fetchArgs[1].headers["authorization"] = "Bearer ".concat(token);
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(UnauthorizeHandler, "handleRefreshFailed", ()=>{
    // remove old tokens
    (0,utils_helpers_cookie__WEBPACK_IMPORTED_MODULE_6__/* .removeCookie */ .nJ)("token");
    localStorage.removeItem("refreshToken");
    // route to login page
    const [currentPath, query] = location.href.split("?");
    let path = "/login?rt=".concat(encodeURIComponent(currentPath));
    if (query) {
        path += "&".concat(query);
    }
    location.href = path;
});


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);